// Module
var code = `<modal on-api-ready="\$ctrl.onModalApiReady" form="\$ctrl.preterminateRevertForm">
  <modal-header><h2>Confirm</h2></modal-header>
  <modal-body>
    <form name="\$ctrl.preterminateRevertForm">
        <div class="modal-body">
          <p>Do you want to revert the pre-termination of this loan?</p>
          <label>Remarks</label>
          <input class="form-control"
                 type="text"
                 autoComplete="off"
                 maxlength="512"
                 required
                 ng-model="\$ctrl.remarks" />
        </div>
    </form>
  </modal-body>
</modal>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/preterminate-revert/preterminate-revert-confirmation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;